(function(){
  'use strict';

  angular
    .module('app.contact')
    .directive('inputFile', inputFileDirective);

  function inputFileDirective() {
    return {
        restrict: 'AE',
        scope: {},
        transclude: false,
		replace: true,
        link: inputFileLink,
        template: `
          <div class="input-file-container" ng-click="inputClick()">
              <input ng-change="inputKeydown(fileName)" ng-model="nameFile" id="my-file" type="file">
              <label tabindex="0" for="my-file" class="{{inputReturn}}">Select a file...</label>
          </div>
        `
    }
  }

	function inputFileLink(scope, element, attrs){
        const input = element.find('input');
        const label = element.find('label');

        input.bind('change', (event) => label.text(event.target.files[0].name))

        scope.inputKeydown = fileName => {
          console.log(fileName);
        }

        scope.inputClick = click => {
          console.log('click');
        }
	}

})();
